import * as httpStatusCodes from 'http-status-codes'
import { ServerResponse } from 'http'

type Args = {
  res: ServerResponse
  url: string
  cookies?: string[]
}

const serverSideRedirectTo = ({ res, url, cookies = [] }: Args): void => {
  if (res && res.writeHead && res.end) {
    res.writeHead(httpStatusCodes.MOVED_TEMPORARILY, {
      Location: url,
      'Set-Cookie': cookies,
    })

    res.end()
  }
  return undefined
}

export default serverSideRedirectTo
